/** Set before `signOut()` so unload presence PATCH is skipped (Safari CORS noise). */
let loggingOut = false;

export function markLoggingOut(): void {
	loggingOut = true;
}

export function isLoggingOut(): boolean {
	return loggingOut;
}

export function clearLoggingOut(): void {
	loggingOut = false;
}
